import { ScrollReveal } from "./ScrollReveal";
import { Button } from "./ui/button";
import { motion } from "framer-motion";
import { FileText, Camera, ShieldCheck, Globe, ArrowRight } from "lucide-react";

const steps = [
  { icon: FileText, title: "Add Details", desc: "Enter property info" },
  { icon: Camera, title: "Upload Photos", desc: "Add quality images" },
  { icon: ShieldCheck, title: "Get Verified", desc: "Team reviews listing" },
  { icon: Globe, title: "Goes Live", desc: "Brokers reach out" },
];

const OwnerListingSection = () => (
  <section className="section-light py-20 sm:py-28">
    <div className="container mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <p className="text-xs font-medium uppercase tracking-[0.15em] text-muted-foreground text-center mb-3">
          For Owners
        </p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center mb-4 text-foreground">
          List Your Property{" "}
          <span className="gradient-text font-extrabold">in Minutes</span>
        </h2>
        <p className="text-center text-muted-foreground mb-14 max-w-md mx-auto text-sm leading-relaxed">
          Property owners can list directly and connect with verified brokers.
        </p>
      </ScrollReveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 max-w-3xl mx-auto mb-10">
        {steps.map((step, i) => (
          <ScrollReveal key={i} delay={i * 0.08}>
            <motion.div
              whileHover={{ y: -3 }}
              className="relative p-5 rounded-2xl bg-background border border-border text-center hover:border-primary/15 hover:shadow-md transition-all duration-300"
            >
              <span className="absolute top-3 right-3 text-[10px] font-semibold text-primary/30">{`0${i + 1}`}</span>
              <div className="w-10 h-10 rounded-xl bg-primary/[0.07] flex items-center justify-center mx-auto mb-3">
                <step.icon className="w-5 h-5 text-primary" />
              </div>
              <h4 className="font-semibold text-xs text-foreground mb-0.5">
                {step.title}
              </h4>
              <p className="text-[11px] text-muted-foreground">{step.desc}</p>
            </motion.div>
          </ScrollReveal>
        ))}
      </div>

      <ScrollReveal>
        <div className="text-center">
          <a href="https://ownerlisting.probroker.in/">
          <Button
            size="lg"
            className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-md shadow-primary/15 rounded-xl h-11 px-6 text-sm font-medium"
          >
            List Your Property <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
          </a>
        </div>
      </ScrollReveal>
    </div>
  </section>
);

export default OwnerListingSection;
